<template>
  <cst-page-template class="settings-page" ds-root :hide-menu="true">
    <header-menu />
    <div class="ds-page">
      <div class="ds-page__header">
        <h1>Instellingen</h1>
      </div>

      <div class="ds-tabs" role="tablist">
        <button
          v-for="(tab, index) in visibleTabs"
          :key="tab.key"
          class="ds-tabs__tab"
          :class="{ 'ds-tabs__tab--active': index === selectedIndex }"
          role="tab"
          :aria-selected="index === selectedIndex"
          data-qa="tab-header-item"
          @click="onTabSelected(index)"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- v-show keeps each tab's state (search results, form input) alive
           across switches, matching the old Tabs component's behaviour. -->
      <div
        v-for="(tab, index) in visibleTabs"
        v-show="index === selectedIndex"
        :key="tab.key"
        role="tabpanel"
      >
        <component :is="tab.component" />
      </div>
    </div>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'
import DealerSettingsTab from './tabs/DealerSettingsTab.vue'
import ToolsTab from './tabs/ToolsTab.vue'
import InstructionalVideosTab from './tabs/InstructionalVideosTab.vue'
import ManualsTab from './tabs/ManualsTab.vue'
import FaqTab from './tabs/FaqTab.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SettingsPage',
  components: {
    CstPageTemplate,
    HeaderMenu,
    DealerSettingsTab,
    ToolsTab,
    InstructionalVideosTab,
    ManualsTab,
    FaqTab,
  },
  computed: {
    ...mapGetters({
      hasAdminToolsAccess: 'user/hasAdminToolsAccess',
    }),
    // The ?tab= query indexes into the visible tabs, so links keep working for
    // users without admin access (their index 0 is Dealer instellingen).
    visibleTabs() {
      const admin = this.hasAdminToolsAccess
      return [
        admin && { key: 'tools', label: 'Tools', component: 'ToolsTab' },
        { key: 'dealer', label: 'Dealer instellingen', component: 'DealerSettingsTab' },
        admin && { key: 'videos', label: "Instructievideo's", component: 'InstructionalVideosTab' },
        admin && { key: 'manuals', label: 'Handleidingen', component: 'ManualsTab' },
        admin && { key: 'faq', label: 'FAQ', component: 'FaqTab' },
      ].filter(Boolean)
    },
    selectedIndex() {
      const tab = parseInt(this.$route.query.tab)
      if (isNaN(tab)) return 0
      return Math.min(Math.max(tab, 0), this.visibleTabs.length - 1)
    },
  },
  methods: {
    onTabSelected(index) {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, tab: index },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// Layout only. The page chrome and tab bar come from the design system
// (styles/ds/). See styles/ds/README.md before adding anything here.
</style>
